import React from 'react'
import { BarChart2, Edit, Map, MapPin, Star } from 'react-feather'

export const MODULES_GROUPS = [
  {
    id: 'locations_group',
    name: 'Locations',
    icon: <MapPin size="1.5rem" color="rgba(47, 43, 61, 0.6)" />,
    modules: [
      {
        name: 'My Locations',
        permission: 'locations',
      },
      {
        name: 'Pending Edits',
        permission: 'edits',
      },
      {
        name: 'Notifications',
        permission: 'notifications',
      },
    ],
  },
  {
    id: 'posts_group',
    name: 'Posts',
    icon: <Edit size="1.5rem" color="rgba(47, 43, 61, 0.6)" />,
    modules: [
      {
        name: 'Posts',
        permission: 'posts',
      },
      {
        name: 'Schedules',
        permission: 'schedules',
      },
    ],
  },
  {
    id: 'bulkEdit_group',
    name: 'Bulk Edit',
    permission: 'infos',
    icon: <Map size="1.5rem" color="rgba(47, 43, 61, 0.6)" />,
  },
  {
    id: 'sac_group',
    name: 'SAC',
    icon: <Star size="1.5rem" color="rgba(47, 43, 61, 0.6)" />,
    modules: [
      {
        name: 'Reviews',
        permission: 'reviews',
      },
      {
        name: 'Questions',
        permission: 'questions',
      },
    ],
  },
  {
    id: 'insights_group',
    name: 'Insights',
    icon: <BarChart2 size="1.5rem" color="rgba(47, 43, 61, 0.6)" />,
    modules: [
      {
        name: 'General and locations',
        permission: 'insights',
      },
      {
        name: 'Keywords',
        permission: 'keywords',
      },
    ],
  },
]
